<div id="consulting">
    <!-- only_desktop -->
<section class="d-none d-md-block mt-5">
    <section class="itc_consulting_home bg-white py-0">
        <div class="bg_img">
            <div class="bg_img_light" fxLayoutAlign="center center">
                <div class="container text-start" fxLayoutAlign="start start" fxLayout="column">
                    <p class="sub_title text-start text-white">Consulting</p>
                    <p class="title text-start text-white">Home Consulting </p>
                </div>
            </div>

        </div>
    </section>

    <!-- CUTTING EDGE TECHNOLOGIES -->
    <section *ngIf="cuttingEdgeTechnologiesHeading?.title" class="itc_consulting_1">
        <div class="container justify-content-center">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-center me-4">
                <div class="col-md-10 py-4 text-start">
                    <p class="sub_title text-dark" [innerHTML]="cuttingEdgeTechnologiesHeading?.title"></p>
                    <p class="titleDescription text-dark"
                        [innerHTML]="cuttingEdgeTechnologiesHeading?.titleDescription">
                    </p>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div class="">
                    <div *ngFor="let point of cuttingEdgeTechnologiesPoints" class="d-flex">
                        <img [appLazyLoadImage]="'../../assets/images/'+point?.image" class="img-fluid px-1"
                            style="height: 5%;" alt="" alt="">
                        <p class="sub_points text-dark px-2" [innerHTML]="point?.title"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- BOLD SOLUTIONS -->
    <section *ngIf="boldSolutionsHeading?.title" class="itc_consulting_2 bg-light">
        <div class="itc_consulting_bg_light">
            <div class="container py-4">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 p-2">
                    <p class="title" [style.color]="themedata.primarytheme" [innerHTML]="boldSolutionsHeading?.heading">
                    </p>
                    <p class="sub_title text-white" [innerHTML]="boldSolutionsHeading?.title"></p>
                    <p class="titleDescription text-white" [innerHTML]="boldSolutionsHeading?.titleDescription"></p>
                </div>

                <div class="d-flex">
                    <div *ngFor="let point of boldSolutionsPoints"
                        class="col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 p-2">
                        <img [appLazyLoadImage]="'../../assets/themes/'+themedata.theme+'/'+point?.image" alt=""
                            class="social-icon my-4" />
                        <!-- <img [appLazyLoadImage]="'../../assets/images/'+point?.image" class="img-fluid" alt /> -->
                        <p class="sub_heading text-white" [innerHTML]="point?.title"></p>
                        <p class="sub_points text-white" [innerHTML]="point?.titleDescription"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- OUR GOALS -->
    <section *ngIf="ourGoalsHeading?.title" class="itc_consulting_7 bg-light">
        <div class="container">
            <div class="col-md-6 px-4">
                <p class="sub_title" [innerHTML]="ourGoalsHeading?.title"></p>
            </div>

            <div class="d-flex" fxLayoutAlign="space-between start">
                <div *ngFor="let point of ourGoalsPoints" class="col-md-6">
                    <p class="titleDescription p-4" [innerHTML]="point?.description"></p>
                </div>
            </div>
        </div>


        <!-- CLOUD COMPUTING SOLUTIONS -->
        <div *ngIf="cloudComputingSolutionsHeading?.title" class="bg-light">
            <div class="container">
                <div class="px-4">
                    <p class="sub_heading" [innerHTML]="cloudComputingSolutionsHeading?.title"></p>

                    <div *ngFor="let point of cloudComputingSolutionsPoints">
                        <span class="d-flex lh-base">
                            <!-- <img src="'../../assets/images/'+point?.image" class="img-fluid px-1"
                                style="height: 5%;" alt=""> -->
                            <img [appLazyLoadImage]="'../../assets/images/'+point?.image" alt="" style="height: 5%;"
                                class="img-fluid me-2">
                            <p class="sub_points" [innerHTML]="point?.description"></p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- TRANSFORM YOUR FUTURE -->
    <section *ngIf="transformYourFutureHeading?.title" class="Consulting_section bg-white">
        <div class="bg_img">
            <div class="bg_light">
                <div class="container">
                    <p class="sub_title" [innerHTML]="transformYourFutureHeading?.heading"></p>

                    <p class="titleDescription col-md-10" [innerHTML]="transformYourFutureHeading?.title"></p>
                    <p class="titleDescription col-md-10" [innerHTML]="transformYourFutureHeading?.titleDescription">
                    </p>
                </div>
            </div>
        </div>

        <div class="container">
            <div *ngFor="let point of transformYourFuturePoints; let i=index" class="section">
                <div class="text">
                    <p class="sub_heading" [innerHTML]="point?.title"></p>
                    <p class="sub_points" [innerHTML]="point?.titleDescription"></p>
                </div>
                <div class="image" [fxLayoutAlign]="(i%2)===0 ? 'end end' : ''">

                    <div class="position-relative">
                        <!-- Overlay -->
                        <div class="overlay position-absolute top-0 bottom-0 start-0 w-100 h-100 rounded-4"
                            style="background: rgba(0, 0, 0, 0.2); z-index: 1;"></div>

                        <!-- Image -->
                        <img style="object-fit: cover; z-index: 0; position: relative;"
                            [appLazyLoadImage]="'../../assets/images/' + point?.imageSmall" [srcset]="
                        '../../assets/images/' +
                        point?.imageSmall +
                        ' 600w, ../../assets/images/' +
                        point?.imageMedium +
                        ' 900w, ../../assets/images/' +
                        point?.imageLarge +
                        ' 1200w'
                      " sizes="(max-width: 500px) 90vw, (max-width: 900px) 80vw, 600px" class="img-fluid rounded-4"
                            alt />
                    </div>


                </div>
            </div>
        </div>
    </section>
</section>

<!-- only_mobile -->
<section class="d-md-none d-lg-none">
    <section class="itc_consulting_home col-sm-12 bg-white py-0">
        <div class="bg_img">
            <div class="bg_img_light" fxLayoutAlign="center center">
                <div class="container text-start" fxLayoutAlign="center center" fxLayout="column">
                    <p class="sub_title text-start text-white">Consulting</p>
                    <p class="title text-start text-white">Home Consulting </p>
                </div>
            </div>
        </div>
    </section>

    <!-- CUTTING EDGE TECHNOLOGIES -->
    <section *ngIf="cuttingEdgeTechnologiesHeading?.title" class="itc_consulting_1 py-4">
        <div class="col-sm-12 px-4" fxLayoutAlign="center center" fxLayout="column">
            <div class="text-start">
                <p class="sub_title text-dark" [innerHTML]="cuttingEdgeTechnologiesHeading?.title"
                    style="font-size: 2.2rem;"></p>
                <p class="titleDescription text-dark" [innerHTML]="cuttingEdgeTechnologiesHeading?.titleDescription">
                </p>
            </div>
            <div class="">
                <div *ngFor="let point of cuttingEdgeTechnologiesPoints" class="d-flex">
                    <img [appLazyLoadImage]="'../../assets/images/'+point?.image" class="img-fluid me-2"
                        style="height: 5%;" alt="" alt="">
                    <p class="sub_points text-dark" [innerHTML]="point?.title"></p>
                </div>
            </div>
        </div>
    </section>

    <!-- BOLD SOLUTIONS -->
    <section *ngIf="boldSolutionsHeading?.title" class="itc_consulting_2  bg-light">
        <div class="itc_consulting_bg_light py-4 px-4">
            <div class="col-sm-12">
                <div class="col-sm-12">
                    <p class="title" [style.color]="themedata.primarytheme" [innerHTML]="boldSolutionsHeading?.heading">
                    </p>
                    <p class="sub_title text-white" [innerHTML]="boldSolutionsHeading?.title"></p>
                    <p class="titleDescription text-white" [innerHTML]="boldSolutionsHeading?.titleDescription"></p>
                </div>

                <div class="col-sm-12">
                    <div *ngFor="let point of boldSolutionsPoints" class="col-sm-12">
                        <img [appLazyLoadImage]="'../../assets/themes/'+themedata.theme+'/'+point?.image" alt=""
                            class="social-icon my-4" />
                        <!-- <img [appLazyLoadImage]="'../../assets/images/'+point?.image" class="img-fluid" alt /> -->
                        <p class="sub_heading text-white" [innerHTML]="point?.title"></p>
                        <p class="sub_points text-white" [innerHTML]="point?.titleDescription"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- OUR GOALS -->
    <section *ngIf="ourGoalsHeading?.title" class="itc_consulting_7 py-4 px-4 bg-light">
        <div class="col-sm-12">
            <div class="">
                <p class="sub_title" [innerHTML]="ourGoalsHeading?.title"></p>
            </div>

            <div class="">
                <div *ngFor="let point of ourGoalsPoints">
                    <p class="titleDescription" [innerHTML]="point?.description"></p>
                </div>
            </div>
        </div>


        <!-- CLOUD COMPUTING SOLUTIONS -->
        <div *ngIf="cloudComputingSolutionsHeading?.title" class="bg-light">
            <div class="col-sm-12">
                <div class="">
                    <p class="sub_heading fs-4 fw-bold lh-base" [innerHTML]="cloudComputingSolutionsHeading?.title">
                    </p>

                    <div *ngFor="let point of cloudComputingSolutionsPoints">
                        <span class="d-flex lh-base">
                            <!-- <img src="'../../assets/images/'+point?.image" class="img-fluid px-1"
                                style="height: 5%;" alt=""> -->
                            <img [appLazyLoadImage]="'../../assets/images/'+point?.image" alt="" style="height: 5%;"
                                class="img-fluid me-2">
                            <p class="sub_points" [innerHTML]="point?.description"></p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- TRANSFORM YOUR FUTURE -->
    <section *ngIf="transformYourFutureHeading?.title" class="Consulting_section bg-white">
        <div class="bg_img">
            <div class="bg_light">
                <div class="col-sm-12 px-4 py-4">
                    <p class="sub_title" [innerHTML]="transformYourFutureHeading?.heading"
                        style="font-size: 2.2rem; line-height: 2.8rem;"></p>

                    <p class="titleDescription" [innerHTML]="transformYourFutureHeading?.title"></p>
                    <p class="titleDescription" [innerHTML]="transformYourFutureHeading?.titleDescription">
                    </p>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div *ngFor="let point of transformYourFuturePoints; let i=index" class="">
                <!-- <hr class="my-4"> -->
                <div class="text px-4 py-2">
                    <p class="sub_heading" [innerHTML]="point?.title"></p>

                    <div class="image py-2" [fxLayoutAlign]="(i%2)===0 ? 'end end' : ''">
                        <!-- <img [appLazyLoadImage]="'../../assets/images/'+point?.image" class="img-fluid rounded-4"
                            alt=""> -->
                            <div class="position-relative">
                                <!-- Overlay -->
                                <div class="overlay position-absolute top-0 bottom-0 start-0 w-100 h-100 rounded-4"
                                    style="background: rgba(0, 0, 0, 0.2); z-index: 1;"></div>
        
                                <!-- Image -->
                                <img style="object-fit: cover; z-index: 0; position: relative;"
                                    [appLazyLoadImage]="'../../assets/images/' + point?.imageSmall" [srcset]="
                                '../../assets/images/' +
                                point?.imageSmall +
                                ' 600w, ../../assets/images/' +
                                point?.imageMedium +
                                ' 900w, ../../assets/images/' +
                                point?.imageLarge +
                                ' 1200w'
                              " sizes="(max-width: 500px) 90vw, (max-width: 900px) 80vw, 600px" class="img-fluid rounded-4"
                                    alt />
                            </div>
                    </div>

                    <p class="sub_points" [innerHTML]="point?.titleDescription"></p>
                </div>
                <hr class="my-0">
            </div>
        </div>
    </section>
</section>
</div>